////////////////////
// spin Functions //
////////////////////

//this is a prototype module which has functions in it used buy both the standard gamecontroller and freespins. Both inherit from this module

spinFunctions = (function() {
	var _spinTask;
	var _winsTask;
	var _reelsSpinning = [];
	var _waitingForSpinTask = false;

	function onSpinEvent(spinTask) {
		spinTask.join();
		_spinTask = spinTask;
		_waitingForSpinTask = false;
		doSpin();
	}

	function onPreSpin() {
		_waitingForSpinTask = true;
	}

	function doSpin() {
		// Both spin task and character must have completed before we stop the reels
		if (_waitingForSpinTask ) return;

		gameController_bonusSymbolsLanded = 0;
	}

	function doPayWins(winsTask) {
		// This is the wrong way to do this, it's a workaround. I have done it because the doPayWins function is being called by a messsage. It messes up the "this" reference for some reason
		var self = freespins.inFreespins ? freespins : gameController;
		_currentWinline = 0;
		_winsTask = winsTask;
		self.stateMachine.switchState("PAYWINS");
		winsTask.join();

		// Start winline animations	
		self.winlineAnimationsComplete = false;
		winlineAnimationController.startWinlineAnimations(_winsTask.data, onWinlineAnimationsComplete, undefined, undefined, undefined, undefined, 9999);
		messageBox.reveal();
	}

	function onWinlineAnimationsComplete() {
		if (freespins.inFreespins) {
			freespins.stateMachine.switchState("PAY_TO_WINNINGS");
		} else {
			gameController.stateMachine.switchState("PAY_TO_WINNINGS");
		}
	}
	
	function doSlamStop() {
		slotMachine.slamStop();
	}

	spinFunctions = {};

	Object.defineProperties(spinFunctions, {
		onSpinEvent: {
			value: onSpinEvent
		},
		onPreSpin: { value: onPreSpin },
		
		spinTask: {
			get: function() {
				return _spinTask;
			},
			set: function( value ) {
				_spinTask = value;
			}
		},

		winsTask: {
			get: function() {
				return _winsTask;
			}
		},
		reelsSpinning: {
			get: function() {
				return _reelsSpinning;
			},
			set: function(value) {
				_reelsSpinning = value;
			}
		},
		doSlamStop: {
			value: doSlamStop
		},		
		doPayWins: {
			value: doPayWins
		},
		longSpinActive: {
			get: function() {
				return _longSpinActive;
			}
		}
	});
	
	return spinFunctions;
})();